import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const style: CSSResult = css`
  .basket-selector-list {
    display:flex;
    flex-direction:column ;
    gap: ${csSpacing.spacing04};
  }
 `
